import React from "react";
import { cn } from "./cn";

/**
 * Bun empty state: dashed boundary, faint icon, one calm sentence, and the
 * action(s) that fill it. Never a full-color illustration.
 */
export default function EmptyState({ icon, title, description, actions, compact = false, className }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-[6px] font-instrument",
        compact ? "items-start py-1 text-left" : "items-center text-center border border-dashed border-bun-line-strong rounded-bun-lg px-6 py-[34px]",
        className
      )}
    >
      {icon && <div className="text-bun-faint mb-[6px] [&>svg]:w-5 [&>svg]:h-5">{icon}</div>}
      {title && <div className={cn(compact ? 'text-bun-body font-strong' : 'text-bun-heading font-semibold', 'text-bun-text')}>{title}</div>}
      {description && (
        <div className="text-bun-meta font-book text-bun-slate leading-relaxed">{description}</div>
      )}
      {actions && <div className="flex items-center gap-2 mt-3">{actions}</div>}
    </div>
  );
}
